'use strict';

require('../../style/');

require('../../icon/style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/toast/style/index.js
// module id = 76
// module chunks = 0